<template>
  <component v-bind:is="currentTab"></component>
</template>

<script>
  import categorias from './categorias/categorias'
  import contenido from './contenido/contenido'
  import estilo from './estilo/estilo'
  import administrador from '../admin/administrador'

  export default {
    name: "regularPrincipal",
    data() {
      return {
        currentTab:  localStorage.getItem('navegar'),
        rol:''
      }
    },
    components: {categorias,contenido,estilo,administrador},
    created(){
      if (localStorage.getItem('navegar') == null){
        localStorage.setItem('navegar','categorias');
      }
    },
    mounted() {
      let self = this;
      EventBus.$on('navegacion', function (data) {
        localStorage.setItem('navegar',data);
        self.currentTab = data;
      });
      EventBus.$on('usuario', function (data) {
        self.rol = data.rol;
      })
    },
    computed: {
    },
    methods: {
      currentTabComponent:function() {
        this.currentTab = "categorias";
        return this.currentTab;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/privada/regular/regularPrincipal.vue